import React from "react";

const ICON_PATHS: Record<string, React.ReactNode> = {
    "ti ti-map-pin": (
        <>
            <path
                d="M17.657 16.657l-4.243 4.243a2 2 0 0 1-2.827 0l-4.244-4.243a8 8 0 1 1 11.314 0z"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9 11a3 3 0 1 0 6 0a3 3 0 0 0-6 0"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </>
    ),
    "ti ti-navigation": (
        <path
            d="M12 3l7 18-7-4-7 4 7-18z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinejoin="round"
        />
    ),
    "ti ti-shield-check": (
        <>
            <path
                d="M12 3l8 4v5a10 10 0 0 1-8 9.8A10 10 0 0 1 4 12V7l8-4z"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.75"
                strokeLinejoin="round"
            />
            <path
                d="M9 12l2 2 4-4"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </>
    ),
    "ti ti-map-pin-share": (
        <>
            <path
                d="M9 11a3 3 0 1 0 6 0a3 3 0 0 0-6 0"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.02 21.27a1.94 1.94 0 0 1-1.17-.4l-4.244-4.243a8 8 0 1 1 13.403-3.92"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16 22l5-5M21 17v4.5M16 21.5V17"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </>
    ),
    "ti ti-user-check": (
        <>
            <circle cx="9" cy="8" r="3" fill="none" stroke="currentColor" strokeWidth="1.75" />
            <path
                d="M3 19c0-3 2.5-5 6-5s6 2 6 5"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.75"
                strokeLinecap="round"
            />
            <path d="M16 11l2 2 4-4" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
        </>
    ),
    "ti ti-brand-google-play": (
        <path
            d="M4 3.5v17l12.5-8.5L4 3.5z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinejoin="round"
        />
    ),
    "ti ti-brand-facebook": (
        <path
            d="M7 10v4h3v8h4v-8h3l1-4h-4V8c0-1 0-2 2-2h2V3h-3c-3 0-5 2-5 5v2H7z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinejoin="round"
        />
    ),
    "ti ti-brand-linkedin": (
        <>
            <rect x="4" y="4" width="16" height="16" rx="2" fill="none" stroke="currentColor" strokeWidth="1.75" />
            <path
                d="M8 11v7M8 8v.01M12 11v7M12 14c0-2 1-3 3-3s3 1 3 3v4"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.75"
            />
        </>
    ),
    "ti ti-brand-youtube": (
        <>
            <rect x="3" y="6" width="18" height="12" rx="3" fill="none" stroke="currentColor" strokeWidth="1.75" />
            <path d="M10 9.5v5l5-2.5-5-2.5z" fill="currentColor" />
        </>
    ),
    "ti ti-brand-instagram": (
        <>
            <rect x="4" y="4" width="16" height="16" rx="4" fill="none" stroke="currentColor" strokeWidth="1.75" />
            <circle cx="12" cy="12" r="3.5" fill="none" stroke="currentColor" strokeWidth="1.75" />
            <circle cx="17" cy="7" r="1" fill="currentColor" />
        </>
    )
};

type LcvRouteIconProps = {
    iconClassName: string;
    className?: string;
};

const LcvRouteIcon = ({ iconClassName, className }: LcvRouteIconProps) => {
    const paths = ICON_PATHS[iconClassName];

    if (!paths) {
        return null;
    }

    return (
        <svg className={className} width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            {paths}
        </svg>
    );
};

export default LcvRouteIcon;
